import { useMutation } from 'react-query'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useDownloadAudienceByAudienceId = () => {
  const dealership = useDealership()
  return useMutation(({ audience_id }: { audience_id: number }) =>
    fetch(
      `${import.meta.env.VITE_API_URL}/agencies/${
        dealership?.organization_id
      }/dealership/${dealership?.id}/customers/audiences/${audience_id}/download`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'text/csv',
          'X-Org-Id': String(dealership?.organization_id),
        },
        credentials: 'include',
      },
    ),
  )
}
